import {combineReducers} from 'redux'
import notariaReducer from './notariaReducer'
// import config from './configReducer'
import auth from './authReducer'

export default combineReducers({
    notaria: notariaReducer,
    auth: auth   
})